(function() {
    "use strict";
    function initAnnouncementBar() {
        var slider = document.querySelector(".announcement-bar__slider");
        if (!slider)
            return;
        var messages = slider.querySelectorAll(".announcement-bar__message"),
            prevBtn = document.querySelector(".announcement-bar__arrow--prev"),
            nextBtn = document.querySelector(".announcement-bar__arrow--next");
        if (messages.length < 2) {
            prevBtn && (prevBtn.style.display = "none"),
            nextBtn && (nextBtn.style.display = "none");
            return
        }
        var current = 0,
            total = messages.length,
            isAnimating = !1,
            autoInterval;
        function slideTo(index) {
            if (!(isAnimating || index === current)) {
                isAnimating = !0;
                var currentMsg = messages[current],
                    nextMsg = messages[index];
                currentMsg.classList.add("is-exiting"),
                currentMsg.classList.remove("is-active"),
                nextMsg.classList.add("is-active"),
                setTimeout(function() {
                    currentMsg.classList.remove("is-exiting"),
                    current = index,
                    isAnimating = !1
                }, 500)
            }
        }
        function next() {
            slideTo((current + 1) % total)
        }
        function prev() {
            slideTo((current - 1 + total) % total)
        }
        function startAuto() {
            autoInterval = setInterval(next, 3500)
        }
        function resetAuto() {
            clearInterval(autoInterval),
            startAuto()
        }
        nextBtn && nextBtn.addEventListener("click", function() {
            next(),
            resetAuto()
        }),
        prevBtn && prevBtn.addEventListener("click", function() {
            prev(),
            resetAuto()
        }),
        startAuto()
    }
    function initMobileMenu() {
        var toggle = document.querySelector(".site-header__menu-toggle"),
            mobileNav = document.querySelector(".site-header__mobile-nav");
        !toggle || !mobileNav || (toggle.addEventListener("click", function() {
            var isOpen = mobileNav.classList.toggle("is-open");
            toggle.setAttribute("aria-expanded", isOpen)
        }), document.addEventListener("click", function(e) {
            !toggle.contains(e.target) && !mobileNav.contains(e.target) && (mobileNav.classList.remove("is-open"), toggle.setAttribute("aria-expanded", "false"))
        }))
    }
    function initSearchToggle() {
        var buttons = document.querySelectorAll(".site-header__search-toggle"),
            searchBar = document.getElementById("site-search"),
            announcementBar = document.querySelector(".announcement-bar");
        if (!buttons.length || !searchBar)
            return;
        var input = searchBar.querySelector(".site-search__input");
        function toggleSearch(clickedBtn) {
            var isOpen = searchBar.classList.toggle("is-open");
            announcementBar && (announcementBar.style.display = isOpen ? "none" : ""),
            buttons.forEach(function(btn) {
                var searchIcon = btn.querySelector(".site-header__search-icon"),
                    closeIcon = btn.querySelector(".site-header__search-close");
                searchIcon && (searchIcon.style.display = isOpen ? "none" : ""),
                closeIcon && (closeIcon.style.display = isOpen ? "" : "none"),
                btn.setAttribute("aria-expanded", isOpen)
            }),
            isOpen && input && input.focus()
        }
        buttons.forEach(function(btn) {
            btn.addEventListener("click", function() {
                toggleSearch(btn)
            })
        })
    }
    function initLoginPanel() {
        var dropdown = document.getElementById("login-dropdown"),
            toggleDesktop = document.getElementById("login-toggle-desktop"),
            dropdownClose = document.getElementById("login-dropdown-close");
        toggleDesktop && dropdown && (toggleDesktop.addEventListener("click", function() {
            dropdown.classList.toggle("is-open")
        }), dropdownClose && dropdownClose.addEventListener("click", function() {
            dropdown.classList.remove("is-open")
        }), document.addEventListener("click", function(e) {
            !dropdown.contains(e.target) && !toggleDesktop.contains(e.target) && dropdown.classList.remove("is-open")
        }));
        var panel = document.getElementById("login-panel"),
            overlay = document.getElementById("login-overlay"),
            closeBtn = document.getElementById("login-close"),
            toggleMobile = document.getElementById("login-toggle-mobile");
        if (panel && overlay) {
            var openPanel = function() {
                    panel.classList.add("is-open"),
                    overlay.classList.add("is-open"),
                    document.body.style.overflow = "hidden"
                },
                closePanel = function() {
                    panel.classList.remove("is-open"),
                    overlay.classList.remove("is-open"),
                    document.body.style.overflow = ""
                };
            toggleMobile && toggleMobile.addEventListener("click", openPanel),
            closeBtn && closeBtn.addEventListener("click", closePanel),
            overlay && overlay.addEventListener("click", closePanel)
        }
    }
    function initFloatingButtons() {
        var promoClose = document.getElementById("promo-close"),
            promoBtn = document.getElementById("promo-btn");
        if (!promoBtn) return;
        if (localStorage.getItem("ff_promo_claimed") === "1") {
            promoBtn.classList.add("is-hidden");
            return;
        }
        promoClose && promoClose.addEventListener("click", function(e) {
            e.stopPropagation();
            promoBtn.classList.add("is-hidden");
        });
        window.addEventListener("klaviyoForms", function(e) {
            if (e.detail && e.detail.formId === "REGfyE" && (e.detail.type === "submit" || e.detail.type === "stepSubmit")) {
                localStorage.setItem("ff_promo_claimed", "1");
                promoBtn.classList.add("is-hidden");
            }
        });
    }
    function initReadMore() {
        var btn = document.getElementById("read-more-btn"),
            desc = document.getElementById("product-description");
        !btn || !desc || btn.addEventListener("click", function() {
            var isCollapsed = desc.classList.contains("is-collapsed");
            isCollapsed ? (desc.classList.remove("is-collapsed"), desc.classList.add("is-expanded"), btn.textContent = "Read Less \u2212") : (desc.classList.add("is-collapsed"), desc.classList.remove("is-expanded"), btn.textContent = "Read More +")
        })
    }
    function initProductGallery() {
        var mainImage = document.querySelector(".product__main-image img"),
            mainWrap = document.querySelector(".product__main-image"),
            thumbnails = document.querySelectorAll(".product__thumbnail");
        if (!mainImage || !thumbnails.length) return;
        thumbnails.forEach(function(thumb) {
            thumb.addEventListener("click", function() {
                var img = thumb.querySelector("img");
                if (!img) return;
                mainImage.src = img.src.replace(/width=\d+/, "width=800");
                mainImage.alt = img.alt;
                var full = thumb.getAttribute("data-full-src");
                if (full) mainImage.setAttribute("data-full-src", full);
                thumbnails.forEach(function(t) { t.classList.remove("is-active") });
                thumb.classList.add("is-active");
            })
        });

        // Mobile swipe: swipe left/right on the main image advances between product images
        // without opening the lightbox. Swipe is detected by horizontal dominance + threshold;
        // a swipe sets didSwipe=true so the capture-phase click handler cancels the subsequent
        // click (which would open the lightbox).
        if (!mainWrap) return;
        var startX = 0, startY = 0, tracking = false, didSwipe = false;
        var SWIPE_THRESHOLD = 40;

        function activeIndex() {
            for (var i = 0; i < thumbnails.length; i++) {
                if (thumbnails[i].classList.contains("is-active")) return i;
            }
            return 0;
        }
        function advance(dir) {
            var idx = (activeIndex() + dir + thumbnails.length) % thumbnails.length;
            thumbnails[idx].click();
        }

        mainWrap.addEventListener("touchstart", function(e) {
            if (e.touches.length !== 1) { tracking = false; return; }
            startX = e.touches[0].clientX;
            startY = e.touches[0].clientY;
            tracking = true;
            didSwipe = false;
        }, { passive: true });

        mainWrap.addEventListener("touchend", function(e) {
            if (!tracking) return;
            tracking = false;
            var t = (e.changedTouches && e.changedTouches[0]) || null;
            if (!t) return;
            var dx = t.clientX - startX, dy = t.clientY - startY;
            if (Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > SWIPE_THRESHOLD) {
                didSwipe = true;
                advance(dx < 0 ? 1 : -1);
                e.preventDefault();
            }
        });

        mainWrap.addEventListener("click", function(e) {
            if (didSwipe) {
                didSwipe = false;
                e.stopPropagation();
                e.preventDefault();
            }
        }, true);
    }
    function initProductLightbox() {
        var lightbox = document.getElementById("pdp-lightbox");
        if (!lightbox) return;
        var mainWrap = document.querySelector(".product__main-image"),
            pageMainImg = document.getElementById("product-main-img"),
            pageThumbs = document.querySelectorAll(".product__thumbnail"),
            closeBtn = document.getElementById("pdp-lightbox-close"),
            prevBtn = document.getElementById("pdp-lightbox-prev"),
            nextBtn = document.getElementById("pdp-lightbox-next"),
            stage = document.getElementById("pdp-lightbox-stage"),
            img = document.getElementById("pdp-lightbox-img"),
            lbThumbs = lightbox.querySelectorAll(".pdp-lightbox__thumb"),
            images = [];
        if (pageThumbs.length) {
            pageThumbs.forEach(function(t) {
                var tImg = t.querySelector("img");
                images.push({ src: t.getAttribute("data-full-src"), alt: tImg ? tImg.alt : "" });
            });
        } else if (pageMainImg) {
            images.push({ src: pageMainImg.getAttribute("data-full-src") || pageMainImg.src, alt: pageMainImg.alt });
        }
        if (!images.length) return;
        var current = 0;
        function render(i) {
            current = (i + images.length) % images.length;
            img.src = images[current].src;
            img.alt = images[current].alt;
            lbThumbs.forEach(function(t, idx) {
                t.classList.toggle("is-active", idx === current);
            });
            unzoom();
        }
        function open(startIndex) {
            render(typeof startIndex === "number" ? startIndex : 0);
            lightbox.classList.add("is-open");
            lightbox.setAttribute("aria-hidden", "false");
            document.body.style.overflow = "hidden";
        }
        function close() {
            lightbox.classList.remove("is-open");
            lightbox.setAttribute("aria-hidden", "true");
            document.body.style.overflow = "";
            unzoom();
        }
        function unzoom() {
            stage.classList.remove("is-zoomed", "is-dragging");
            img.style.transform = "";
        }
        function getActiveThumbIndex() {
            var active = document.querySelector(".product__thumbnail.is-active");
            if (!active) return 0;
            var idx = active.getAttribute("data-index");
            return idx ? parseInt(idx, 10) : 0;
        }
        mainWrap && mainWrap.addEventListener("click", function() { open(getActiveThumbIndex()); });
        mainWrap && mainWrap.addEventListener("keydown", function(e) {
            if (e.key === "Enter" || e.key === " ") { e.preventDefault(); open(getActiveThumbIndex()); }
        });
        closeBtn && closeBtn.addEventListener("click", close);
        prevBtn && prevBtn.addEventListener("click", function(e) { e.stopPropagation(); render(current - 1); });
        nextBtn && nextBtn.addEventListener("click", function(e) { e.stopPropagation(); render(current + 1); });
        lbThumbs.forEach(function(t) {
            t.addEventListener("click", function(e) {
                e.stopPropagation();
                var idx = parseInt(t.getAttribute("data-index"), 10);
                render(idx);
            });
        });
        document.addEventListener("keydown", function(e) {
            if (!lightbox.classList.contains("is-open")) return;
            if (e.key === "Escape") close();
            else if (e.key === "ArrowLeft") render(current - 1);
            else if (e.key === "ArrowRight") render(current + 1);
        });
        var MIN_SCALE = 1, MAX_SCALE = 3, TAP_SCALE = 2;
        var scale = 1, tx = 0, ty = 0;
        var dragging = false, didDrag = false, startX = 0, startY = 0, rafPending = false;
        var pinching = false, pinchStartDist = 0, pinchStartScale = 1, pinchSuppressClick = false;
        function applyTransform() {
            if (scale <= MIN_SCALE) { img.style.transform = ""; return; }
            img.style.transform = "scale(" + scale + ") translate(" + (tx / scale) + "px, " + (ty / scale) + "px)";
        }
        function setScale(s) {
            scale = Math.max(MIN_SCALE, Math.min(MAX_SCALE, s));
            if (scale > MIN_SCALE) {
                stage.classList.add("is-zoomed");
            } else {
                stage.classList.remove("is-zoomed", "is-dragging");
                tx = 0; ty = 0;
            }
            applyTransform();
        }
        // Override unzoom() defined earlier to reset dynamic scale
        unzoom = function() {
            scale = MIN_SCALE; tx = 0; ty = 0;
            stage.classList.remove("is-zoomed", "is-dragging");
            img.style.transform = "";
        };
        function dist(t1, t2) {
            var dx = t1.clientX - t2.clientX, dy = t1.clientY - t2.clientY;
            return Math.sqrt(dx * dx + dy * dy);
        }
        stage.addEventListener("click", function(e) {
            if (e.target.closest(".pdp-lightbox__nav")) return;
            if (didDrag) { didDrag = false; return; }
            if (pinchSuppressClick) { pinchSuppressClick = false; return; }
            if (scale <= MIN_SCALE) setScale(TAP_SCALE);
            else unzoom();
        });
        // Mouse drag-to-pan
        stage.addEventListener("mousedown", function(e) {
            if (scale <= MIN_SCALE) return;
            dragging = true; didDrag = false;
            stage.classList.add("is-dragging");
            startX = e.clientX - tx; startY = e.clientY - ty;
        });
        document.addEventListener("mousemove", function(e) {
            if (!dragging) return;
            e.preventDefault();
            var nx = e.clientX - startX, ny = e.clientY - startY;
            if (Math.abs(nx - tx) > 2 || Math.abs(ny - ty) > 2) didDrag = true;
            tx = nx; ty = ny;
            if (!rafPending) {
                rafPending = true;
                requestAnimationFrame(function() { applyTransform(); rafPending = false; });
            }
        });
        document.addEventListener("mouseup", function() {
            if (!dragging) return;
            dragging = false;
            stage.classList.remove("is-dragging");
        });
        // Touch: pinch-to-zoom + 1-finger pan when zoomed + 1-finger swipe when unzoomed
        var swipeTracking = false, swipeStartX = 0, swipeStartY = 0, swipeFired = false;
        var SWIPE_THRESHOLD = 40;
        stage.addEventListener("touchstart", function(e) {
            if (e.touches.length === 2) {
                pinching = true;
                pinchStartDist = dist(e.touches[0], e.touches[1]);
                pinchStartScale = scale;
                dragging = false;
                swipeTracking = false;
                stage.classList.remove("is-dragging");
            } else if (e.touches.length === 1 && scale > MIN_SCALE) {
                dragging = true; didDrag = false;
                swipeTracking = false;
                stage.classList.add("is-dragging");
                startX = e.touches[0].clientX - tx;
                startY = e.touches[0].clientY - ty;
            } else if (e.touches.length === 1 && images.length > 1) {
                // Unzoomed: track potential horizontal swipe to change image
                swipeTracking = true;
                swipeFired = false;
                swipeStartX = e.touches[0].clientX;
                swipeStartY = e.touches[0].clientY;
            }
        }, { passive: true });
        document.addEventListener("touchmove", function(e) {
            if (pinching && e.touches.length === 2) {
                e.preventDefault();
                var d = dist(e.touches[0], e.touches[1]);
                setScale(pinchStartScale * (d / pinchStartDist));
            } else if (dragging && e.touches.length === 1) {
                e.preventDefault();
                var pt = e.touches[0];
                var nx = pt.clientX - startX, ny = pt.clientY - startY;
                if (Math.abs(nx - tx) > 2 || Math.abs(ny - ty) > 2) didDrag = true;
                tx = nx; ty = ny;
                if (!rafPending) {
                    rafPending = true;
                    requestAnimationFrame(function() { applyTransform(); rafPending = false; });
                }
            }
        }, { passive: false });
        document.addEventListener("touchend", function(e) {
            if (pinching) {
                pinching = false;
                pinchSuppressClick = true;
                if (scale < 1.1) unzoom();
                setTimeout(function() { pinchSuppressClick = false; }, 300);
            }
            if (dragging && e.touches.length === 0) {
                dragging = false;
                stage.classList.remove("is-dragging");
            }
            if (swipeTracking) {
                swipeTracking = false;
                var t = (e.changedTouches && e.changedTouches[0]) || null;
                if (t) {
                    var dx = t.clientX - swipeStartX, dy = t.clientY - swipeStartY;
                    if (Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > SWIPE_THRESHOLD) {
                        swipeFired = true;
                        didDrag = true; // suppress the tap-to-zoom click
                        render(dx < 0 ? current + 1 : current - 1);
                    }
                }
            }
        });
    }
    function initQuantitySelectors() {
        document.querySelectorAll(".product__quantity").forEach(function(wrapper) {
            var input = wrapper.querySelector(".product__quantity-input"),
                minus = wrapper.querySelector('[data-action="decrease"]'),
                plus = wrapper.querySelector('[data-action="increase"]');
            input && (minus && minus.addEventListener("click", function() {
                var val = parseInt(input.value, 10);
                val > 1 && (input.value = val - 1)
            }), plus && plus.addEventListener("click", function() {
                var val = parseInt(input.value, 10);
                input.value = val + 1
            }))
        })
    }
    function initCartDrawer() {
        var drawer = document.getElementById("cart-drawer"),
            overlay = document.getElementById("cart-overlay"),
            closeBtn = document.getElementById("cart-drawer-close"),
            toggleBtn = document.getElementById("cart-toggle");
        if (!drawer)
            return;
        function openCart() {
            renderCartDrawer(),
            drawer.classList.add("is-open"),
            overlay.classList.add("is-active"),
            document.body.style.overflow = "hidden"
        }
        function closeCart() {
            drawer.classList.remove("is-open"),
            overlay.classList.remove("is-active"),
            document.body.style.overflow = ""
        }
        toggleBtn && toggleBtn.addEventListener("click", openCart),
        closeBtn && closeBtn.addEventListener("click", closeCart),
        overlay && overlay.addEventListener("click", closeCart),
        window.openCartDrawer = openCart,
        window.closeCartDrawer = closeCart
    }
    function renderCartDrawer() {
        fetch("/cart.json").then(function(res) {
            return res.json()
        }).then(function(cart) {
            var body = document.getElementById("cart-drawer-body"),
                footer = document.getElementById("cart-drawer-footer"),
                subtotal = document.getElementById("cart-drawer-subtotal"),
                shippingThreshold = 1e4,
                shippingBar = document.getElementById("cart-shipping-bar"),
                shippingFill = document.getElementById("cart-shipping-fill"),
                shippingTruck = document.getElementById("cart-shipping-truck"),
                shippingMsg = document.getElementById("cart-shipping-message");
            if (shippingBar) {
                var pct = Math.min(cart.total_price / shippingThreshold * 100, 100);
                if (shippingFill.style.width = "0%", shippingTruck.style.left = "0%", shippingFill.classList.remove("is-animating"), shippingTruck.classList.remove("is-animating"), shippingFill.offsetWidth, shippingFill.classList.add("is-animating"), shippingTruck.classList.add("is-animating"), shippingFill.style.width = pct + "%", shippingTruck.style.left = pct + "%", cart.total_price >= shippingThreshold)
                    shippingTruck.classList.add("is-complete"),
                    shippingMsg.innerHTML = "You've unlocked <strong>FREE SHIPPING</strong>!";
                else {
                    shippingTruck.classList.remove("is-complete");
                    var remaining = ((shippingThreshold - cart.total_price) / 100).toFixed(2);
                    shippingMsg.innerHTML = "You are $" + remaining + " away from <strong>FREE SHIPPING</strong>"
                }
            }
            if (cart.item_count === 0) {
                body.innerHTML = '<div class="cart-drawer__empty"><p><strong>YOUR CART IS EMPTY!</strong></p><p class="cart-drawer__empty-sub">Add your favorite items to your cart.</p><a href="/collections/supplements">Shop Now</a></div>',
                footer.style.display = "none";
                return
            }
            var html = "";
            cart.items.forEach(function(item) {
                var imgSrc = item.image ? item.image.replace(/(\.[^.]+)$/, "_200x$1") : "",
                    variantTitle = item.variant_title || "",
                    planName = item.selling_plan_allocation && item.selling_plan_allocation.selling_plan ? item.selling_plan_allocation.selling_plan.name : "";
                html += '<div class="cart-drawer__item" data-key="' + item.key + '">',
                html += '  <img src="' + imgSrc + '" alt="' + item.title + '" class="cart-drawer__item-image">',
                html += '  <div class="cart-drawer__item-info">',
                html += '    <a href="' + item.url + '" class="cart-drawer__item-title">' + item.product_title + "</a>",
                variantTitle && (html += '    <span class="cart-drawer__item-variant">' + variantTitle + "</span>"),
                planName && (html += '    <span class="cart-drawer__item-subscription"><span class="cart-drawer__item-sub-badge">Subscription</span><span class="cart-drawer__item-sub-freq">' + planName + "</span></span>"),
                html += '    <span class="cart-drawer__item-price">$' + (item.final_line_price / 100).toFixed(2) + "</span>",
                html += '    <div class="cart-drawer__item-actions">',
                html += '      <button class="cart-drawer__qty-btn" data-cart-change="' + item.key + '" data-qty="' + (item.quantity - 1) + '">\u2212</button>',
                html += '      <span class="cart-drawer__qty">' + item.quantity + "</span>",
                html += '      <button class="cart-drawer__qty-btn" data-cart-change="' + item.key + '" data-qty="' + (item.quantity + 1) + '">+</button>',
                html += '      <button class="cart-drawer__item-remove" data-cart-change="' + item.key + '" data-qty="0">Remove</button>',
                html += "    </div>",
                html += "  </div>",
                html += "</div>"
            }),
            body.innerHTML = html,
            footer.style.display = "block",
            subtotal.textContent = "$" + (cart.total_price / 100).toFixed(2),
            body.querySelectorAll("[data-cart-change]").forEach(function(btn) {
                btn.addEventListener("click", function() {
                    var key = btn.getAttribute("data-cart-change"),
                        qty = parseInt(btn.getAttribute("data-qty"));
                    fetch("/cart/change.js", {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json"
                        },
                        body: JSON.stringify({
                            id: key,
                            quantity: qty
                        })
                    }).then(function(res) {
                        return res.json()
                    }).then(function() {
                        updateCartCount(),
        initWishlist(),
                        renderCartDrawer()
                    })
                })
            })
        })
    }
    function updateCartCount() {
        fetch("/cart.json").then(function(res) {
            return res.json()
        }).then(function(cart) {
            document.querySelectorAll("[data-cart-count]").forEach(function(el) {
                el.textContent = cart.item_count
            })
        }).catch(function() {})
    }
    function initSubscriptionToggle() {
        document.querySelectorAll('form[action="/cart/add"]').forEach(function(form) {
            var radios = form.querySelectorAll('input[name="purchase_type"]'),
                planInput = form.querySelector('[data-subscribe-plan-id]');
            if (!radios.length || !planInput) return;
            var planId = planInput.getAttribute("data-subscribe-plan-id");
            function sync() {
                var selected = form.querySelector('input[name="purchase_type"]:checked');
                if (!selected) return;
                if (selected.value === "subscribe") {
                    planInput.setAttribute("name", "selling_plan");
                    planInput.value = planId;
                    planInput.disabled = false;
                } else {
                    planInput.removeAttribute("name");
                    planInput.value = "";
                    planInput.disabled = true;
                }
            }
            radios.forEach(function(r) { r.addEventListener("change", sync); });
            sync();
        });
    }
    function initAddToCart() {
        document.querySelectorAll('form[action="/cart/add"]').forEach(function(form) {
            form.addEventListener("submit", function(e) {
                e.preventDefault();
                var btn = form.querySelector(".product__add-to-cart");
                btn && (btn.disabled = !0);
                var formData = new FormData(form);
                var selectedType = form.querySelector('input[name="purchase_type"]:checked');
                if (selectedType && selectedType.value === "onetime") {
                    formData.delete("selling_plan");
                }
                fetch("/cart/add.js", {
                    method: "POST",
                    body: formData
                }).then(function(res) {
                    return res.json()
                }).then(function() {
                    if (updateCartCount(), btn) {
                        var originalText = btn.textContent;
                        btn.textContent = "Added!",
                        setTimeout(function() {
                            btn.textContent = originalText,
                            btn.disabled = !1
                        }, 1500)
                    }
                    window.openCartDrawer && window.openCartDrawer()
                }).catch(function() {
                    btn && (btn.disabled = !1)
                })
            })
        })
    }

    /* --- Wishlist (localStorage) --- */
    function initWishlist() {
        var STORAGE_KEY = 'fortifem_wishlist';
        function getWishlist() { return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]'); }
        function saveWishlist(list) { localStorage.setItem(STORAGE_KEY, JSON.stringify(list)); }
        function isInWishlist(handle) { return getWishlist().some(function(item) { return item.handle === handle; }); }
        function updateButtons() {
            document.querySelectorAll('[data-wishlist-add]').forEach(function(btn) {
                var handle = btn.getAttribute('data-product-handle');
                if (isInWishlist(handle)) {
                    btn.classList.add('is-active');
                    btn.querySelector('svg').setAttribute('fill', 'currentColor');
                } else {
                    btn.classList.remove('is-active');
                    btn.querySelector('svg').setAttribute('fill', 'none');
                }
            });
        }
        document.addEventListener('click', function(e) {
            var btn = e.target.closest('[data-wishlist-add]');
            if (!btn) return;
            e.preventDefault();
            e.stopPropagation();
            var handle = btn.getAttribute('data-product-handle');
            var wishlist = getWishlist();
            if (isInWishlist(handle)) {
                wishlist = wishlist.filter(function(item) { return item.handle !== handle; });
            } else {
                wishlist.push({ handle: handle, title: btn.getAttribute('data-product-title'), price: btn.getAttribute('data-product-price'), image: btn.getAttribute('data-product-image') });
            }
            saveWishlist(wishlist);
            updateButtons();
            window.dispatchEvent(new CustomEvent('wishlist:updated'));
        });
        updateButtons();
        window.addEventListener('wishlist:updated', updateButtons);
    }

    document.addEventListener("DOMContentLoaded", function() {
        initAnnouncementBar(),
        initMobileMenu(),
        initSearchToggle(),
        initLoginPanel(),
        initFloatingButtons(),
        initReadMore(),
        initProductGallery(),
        initProductLightbox(),
        initQuantitySelectors(),
        initSubscriptionToggle(),
        initAddToCart(),
        initCartDrawer(),
        updateCartCount(),
        initWishlist()
    })
})();

